var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowcases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 65.733a2.754 2.754 0 0 1-2.965-2.714c0-6.377-4.342-11.5-8.939-16.924-4.932-5.821-10.033-11.838-10.033-19.895a21.937 21.937 0 0 1 43.874 0c0 8.054-5.1 14.071-10.033 19.892-4.6 5.424-8.939 10.547-8.939 16.924A2.754 2.754 0 0 1 35 65.733Zm0-59.466A19.959 19.959 0 0 0 15.063 26.2c0 7.319 4.859 13.054 9.559 18.6 4.628 5.46 9.413 11.106 9.413 18.217 0 .645.675.714.965.714.161 0 .965-.034.965-.714 0-7.111 4.785-12.757 9.413-18.217 4.7-5.545 9.559-11.28 9.559-18.6A19.959 19.959 0 0 0 35 6.267Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.232 37.683a3.456 3.456 0 0 1-3.442-3.45V18.967a3.446 3.446 0 0 1 5.093-3.026L44.9 23.57a3.445 3.445 0 0 1 0 6.052l-14.019 7.636a3.444 3.444 0 0 1-1.649.425Zm0-20.166a1.427 1.427 0 0 0-.737.208 1.412 1.412 0 0 0-.708 1.242v15.266a1.443 1.443 0 0 0 2.137 1.267l14.024-7.636a1.446 1.446 0 0 0 0-2.54L29.929 17.7a1.446 1.446 0 0 0-.692-.183ZM26.79 34.233Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcases);
export default __webpack_public_path__ + "static/media/showcases.96c2b863c9561afca96066beab38de9d.svg";
export { ForwardRef as ReactComponent };